import React, { Component } from 'react';
import PropTypes from 'prop-types';

// External Dependencies
import Button from 'material-ui-next/Button';
import PlusboxIcon from 'mdi-material-ui/PlusBox';
import Toolbar from 'material-ui-next/Toolbar';
import TextField from 'material-ui/TextField';
import { red } from 'material-ui-next/colors';

// Local Dependencies
import connectComponent from '../../connect-component';
import { dialogOpen } from '../../state/ui/update-ninjas/add-ninja-dialog/actions';
import { searchString } from '../../state/ui/update-ninjas/actions/actions';

// MUI Colors
const red500 = red['500'];

const rightChildStyles = {
  position: 'absolute',
  right: 0,
};

const searchTextBox = {
  color: 'white',
  float: 'right',
  paddingRight: 4,
};

const hintStyle = {
  color: 'grey',
  fontWeight: '100',
};

const inputStyle = {
  color: red500,
};

const underlineStyles = {
  color: red500,
};

const addStyles = {
  paddingLeft: 10,
};

class NinjasToolBar extends Component {

  static propTypes = {
    onSearchString: PropTypes.func,
    updateDialogStatus: PropTypes.func,
  };

  static defaultProps = {
    onSearchString: null,
    updateDialogStatus: null,
  };

  updateSearch = (event) => {
    this.props.onSearchString(event.target.value.substr(0, 20).toLowerCase());
  }

  handleAddClick = (e) => {
    e.stopPropagation();
    this.props.updateDialogStatus(true);
  }

  render() {
    const toolBarStyles = {
      color: 'red',
    };

    const buttonStyles = {
      paddingLeft: 0,
      marginLeft: 0,
    };

    const addNinja = (
      <Button style={buttonStyles} color="secondary" onClick={this.handleAddClick}>
        <PlusboxIcon color="red" />
        <span style={addStyles}>Add a Ninja</span>
      </Button>
    );

    const renderTextField = (
      <div>
        <TextField
          hintStyle={hintStyle}
          hintText={<div>&nbsp;🔎 &nbsp;&nbsp;&nbsp;Search by name</div>}
          inputStyle={inputStyle}
          style={searchTextBox}
          underlineFocusStyle={underlineStyles}
          onChange={event => this.updateSearch(event)}
        />
      </div>
    );

    return (
      <Toolbar styles={toolBarStyles}>
        {addNinja}
        <div style={rightChildStyles}>
          {renderTextField}
        </div>
      </Toolbar>
    );
  }
}

export default connectComponent(() => {
}, {
  onSearchString: searchString,
  updateDialogStatus: dialogOpen,
}, NinjasToolBar);




/** WEBPACK FOOTER **
 ** ./src/dashboard/update-ninjas/ninjas-toolbar.js
 **/